/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    SearchRuleOrderValue,
    SearchRuleOrderValueFromJSON,
    SearchRuleOrderValueFromJSONTyped,
    SearchRuleOrderValueToJSON,
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRuleQuery
 */
export interface SearchRuleQuery {
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SearchRuleQuery
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof SearchRuleQuery
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof SearchRuleQuery
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleQuery
     */
    agencyOnly?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleQuery
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleQuery
     */
    relevance?: number | null;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof SearchRuleQuery
     */
    origin?: StationOrLocationItem;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof SearchRuleQuery
     */
    destination?: StationOrLocationItem;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof SearchRuleQuery
     */
    supplier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof SearchRuleQuery
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleQuery
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleQuery
     */
    orderByDescending?: boolean;
    /**
     * 
     * @type {SearchRuleOrderValue}
     * @memberof SearchRuleQuery
     */
    orderValue?: SearchRuleOrderValue;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleQuery
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleQuery
     */
    limit?: number | null;
}

export function SearchRuleQueryFromJSON(json: any): SearchRuleQuery {
    return SearchRuleQueryFromJSONTyped(json, false);
}

export function SearchRuleQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'agencyOnly': !exists(json, 'agencyOnly') ? undefined : json['agencyOnly'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'origin': !exists(json, 'origin') ? undefined : StationOrLocationItemFromJSON(json['origin']),
        'destination': !exists(json, 'destination') ? undefined : StationOrLocationItemFromJSON(json['destination']),
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdCodeAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'orderByDescending': !exists(json, 'orderByDescending') ? undefined : json['orderByDescending'],
        'orderValue': !exists(json, 'orderValue') ? undefined : SearchRuleOrderValueFromJSON(json['orderValue']),
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function SearchRuleQueryToJSON(value?: SearchRuleQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'agencyOnly': value.agencyOnly,
        'description': value.description,
        'relevance': value.relevance,
        'origin': StationOrLocationItemToJSON(value.origin),
        'destination': StationOrLocationItemToJSON(value.destination),
        'supplier': GuidIdCodeAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'showDeleted': value.showDeleted,
        'orderByDescending': value.orderByDescending,
        'orderValue': SearchRuleOrderValueToJSON(value.orderValue),
        'offset': value.offset,
        'limit': value.limit,
    };
}


